import { axios as client } from './apiAdmin'

export const accBonusProgramsApi = {
  getAgg: (data) =>
    client.get('cc/bonus/programs/summary', { params: data }).then((res) => res.data),

  getList: (data) =>
    client.get('cc/bonus/programs/list', { params: data }).then((res) => res.data),

  getPublishers: (data) =>
    client
      .get(`cc/bonus/programs/${data.programId}/publishers`, { params: data })
      .then((res) => res.data),
}

export default accBonusProgramsApi
